module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/citi@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/citi@2x.png
// module id = 1165
// module chunks = 0